import { Box, Typography } from '@mui/material';

export default function SplashScreen(props) {
  document.body.style = 'background: #f2f2f2';
  const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
  return (
    <Box>
      <Box mt={30}>
        <Box>
          <Typography variant="h6" align="center" color={appThemeColor}>Congratulations {props.username}!</Typography>
        </Box>
        <Box mt={1}>
          <Typography variant="subtitle1" align="center" > We’re preparing your ITILive Console</Typography>
        </Box>
      </Box>
    </Box>
  )
}
